module.exports = __webpack_public_path__ + "img/funnel-zamo.605fc667.png";